import SearchPage from '@/pages/buyer/SearchPage';
import { DesktopSearchPage } from '@/pages/desktop/DesktopSearchPage';
import { BottomNavigation } from '@/components/common/BottomNavigation';

export function ResponsiveSearchPage() {
  return (
    <>
      {/* Mobile version */}
      <div className="lg:hidden">
        <div className="mobile-container bg-white min-h-screen relative">
          <SearchPage />
          <BottomNavigation activeId="search" />
        </div>
      </div>
      
      {/* Desktop version */}
      <div className="hidden lg:block">
        <DesktopSearchPage />
      </div>
    </>
  );
}